export const THEME_STORAGE_KEY = "theme";

export const prefersDarkTheme = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-color-scheme: dark)").matches;

export const getStoredThemePreference = () =>
  typeof window === "undefined"
    ? null
    : localStorage.getItem(THEME_STORAGE_KEY);

export const isDarkThemeEnabled = () => {
  const storedTheme = getStoredThemePreference();
  return storedTheme ? storedTheme === "dark" : prefersDarkTheme();
};

export const applyThemePreference = (isDarkMode) => {
  if (typeof document === "undefined") {
    return;
  }

  document.documentElement.classList.toggle("dark", isDarkMode);

  if (typeof window !== "undefined") {
    localStorage.setItem(THEME_STORAGE_KEY, isDarkMode ? "dark" : "light");
  }
};
